// import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
// import {
//   Box,
//   TextField,
//   Typography,
//   CircularProgress,
//   useTheme,
// } from "@mui/material";
// import CryptoJS from "crypto-js";

// const AppAddressDetails = forwardRef(({ handleFieldChange, initialData }, ref) => {
//   const theme = useTheme();
//   const [formData, setFormData] = useState({
//     employee_id: 0,
//     permanent_address: "",
//     present_address: "",
//     present_city: "",
//     country: "",
//   });
//   const [successMessage, setSuccessMessage] = useState("");
//   const [errorMessage, setErrorMessage] = useState("");
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     if (initialData) {
//       setFormData((prev) => ({ ...prev, ...initialData }));
//     }
//   }, [initialData]);

//   const handleChange = (event) => {
//     const { name, value } = event.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//     handleFieldChange("addressDetails", name, value);
//   };

//   const handleSubmit = async () => {
//     setLoading(true);
//     try {
//       const isAddressEmpty =
//         !formData.permanent_address &&
//         !formData.present_address &&
//         !formData.present_city &&
//         !formData.country;
//       if (isAddressEmpty) return null;

//       const encryptedapikey = sessionStorage.getItem("encrypted_data");
//       const base64Key = sessionStorage.getItem("base64_Key");
//       let decryptedjwt = "";

//       if (base64Key && encryptedapikey) {
//         const key = CryptoJS.enc.Base64.parse(base64Key);
//         const dataBytes = CryptoJS.enc.Base64.parse(encryptedapikey);
//         const iv = CryptoJS.lib.WordArray.create(dataBytes.words.slice(0, 4));
//         const ciphertext = CryptoJS.lib.WordArray.create(dataBytes.words.slice(4));
//         const decryptedBytes = CryptoJS.AES.decrypt({ ciphertext }, key, { iv });
//         decryptedjwt = CryptoJS.enc.Utf8.stringify(decryptedBytes);
//       }
//       const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/add-address-details`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "X-API-Key": decryptedjwt,
//           'Authorization': `Bearer ${accessToken}`
//         },
//         body: JSON.stringify(formData),
//       });

//       const data = await response.json();
//       if (response.ok) {
//         return formData;
//       } else {
//         setErrorMessage(data.error || "Error occurred while saving address.");
//         return false;
//       }
//     } catch (error) {
//       setErrorMessage("An error occurred while inserting Address.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useImperativeHandle(ref, () => ({
//     handleSubmit,
//   }));

//   return (
//     <Box
//       sx={{
//         maxWidth: 800,
//         margin: "50px auto",
//         padding: 3,
//       }}
//     >
//      {loading && (
//   <Box
//     sx={{
//       position: "fixed",
//       top: 0,
//       left: 0,
//       width: "100vw",
//       height: "100vh",
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "center",

//     }}
//   >
//     <CircularProgress color="secondary" />
//   </Box>
// )}

//       <Typography
//         variant="h5"
//         align="center"
//         sx={{
//           fontWeight: "bold",
//           color: theme.palette.text.primary,
//           mb: 3,
//         }}
//       >
//         Add Employee Address
//       </Typography>

//       <Box component="form" sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
//         {["permanent_address", "present_address", "present_city", "country"].map((field) => (
//      <TextField
//      key={field}
//      name={field}
//      label={field.replace("_", " ").toUpperCase()}
//      value={formData[field]}
//      onChange={handleChange}
//      fullWidth
//      variant="outlined"
//      InputLabelProps={{
//        shrink: true,
//        sx: {
//          color: theme.palette.mode === "dark" ? "#fff" : "inherit",
//          "&.Mui-focused": {
//            color: theme.palette.mode === "dark" ? "#fff" : theme.palette.primary.main,
//          },
//        },
//      }}
//      sx={{
//        "& .MuiOutlinedInput-root": {
//          borderRadius: 2,
//          backgroundColor:
//            theme.palette.mode === "dark" ? "" : theme.palette.background.default,
//          color: theme.palette.text.primary,

//          "&.Mui-focused": {
//            backgroundColor: theme.palette.mode === "dark" ? "hsla(180, 17.20%, 25.10%, 0.92)" : "#f5f5f5",
//          },

//          "& fieldset": {
//            borderColor:
//              theme.palette.mode === "dark"
//                ? ""
//                : "#ccc",
//          },
//          "&:hover fieldset": {
//            borderColor: theme.palette.primary.main,
//          },
//          "&.Mui-focused fieldset": {
//           borderColor: theme.palette.mode === "dark" ? "white" : "#f5f5f5",
//          },
//        },
//        "& .MuiInputBase-input": {
//          color: theme.palette.text.primary,
//        },
//      }}
//    />

//         ))}
//       </Box>

//       {successMessage && (
//         <Typography sx={{ mt: 2, color: "green", textAlign: "center" }}>
//           {successMessage}
//         </Typography>
//       )}
//       {errorMessage && (
//         <Typography sx={{ mt: 2, color: "red", textAlign: "center" }}>
//           {errorMessage}
//         </Typography>
//       )}
//     </Box>
//   );
// });

// export default AppAddressDetails;

import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import { useNavigate } from "react-router-dom";
import { tokens } from "../../../../../theme";
import CryptoJS from "crypto-js";
import {
  Container,
  TextField,
  Snackbar,
  Alert,
  CircularProgress,
  Box,
  Typography,
  useTheme,
} from "@mui/material";
import { useParams } from "react-router-dom";

const AppAddressDetails = forwardRef(({ handleFieldChange, initialData }, ref) => {
    const { employeeId } = useParams();
    const theme = useTheme();
    const navigate = useNavigate();
    const colors = tokens(theme.palette.mode);

    const [formData, setFormData] = useState({
      permanent_address: "",
      present_address: "",
      present_city: "",
      country: "",
    });

    const [loading, setLoading] = useState(false);
    const [addressExists, setAddressExists] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [hasInitialized, setHasInitialized] = useState(false);

    useEffect(() => {
        if (!employeeId && initialData && !hasInitialized) {
          setFormData({
            permanent_address: initialData.permanent_address === "NA" ? "" : initialData.permanent_address || "",
            present_address: initialData.present_address === "NA" ? "" : initialData.present_address || "",
            present_city: initialData.present_city === "NA" ? "" : initialData.present_city || "",
            country: initialData.country === "NA" ? "" : initialData.country || "",
          });
          setAddressExists(false);
          setHasInitialized(true);
          return;
        }

      if (!employeeId || hasInitialized) return;

      const fetchAddress = async () => {
        setLoading(true);
        try {
          const accessToken = JSON.parse(localStorage.getItem("emsUser"))?.user?.stsTokenManager?.accessToken;

          const response = await fetch(
            `${process.env.REACT_APP_BACKEND_URL_HRM}/get-address-details/${employeeId}`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
            }
          );

          if (!response.ok) throw new Error("Failed to fetch address details");

          const data = await response.json();
          if (data.status === "success" && data.addressDetails) {
            const addr = data.addressDetails;
            setFormData({
              permanent_address: addr.Permanent_Address === "NA" ? "" : addr.Permanent_Address,
              present_address: addr.Present_Address === "NA" ? "" : addr.Present_Address,
              present_city: addr.Present_City === "NA" ? "" : addr.Present_City,
              country: addr.Country === "NA" ? "" : addr.Country,
            });
            setAddressExists(true);
            if (handleFieldChange) {
              handleFieldChange("addressDetails", null, data.addressDetails);
            }
          } else {
            setAddressExists(false);
          }
        } catch (err) {
          console.error(err);
          setSnackbarMessage("Error loading address details.");
          setSnackbarSeverity("error");
          setOpenSnackbar(true);
        } finally {
          setLoading(false);
        }
      };

      fetchAddress();
    }, [employeeId]);


    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData((prev) => ({ ...prev, [name]: value }));

      if (handleFieldChange) {
        handleFieldChange("addressDetails", name, value);
      }
    };

      const handleSave = async (corporateEmail) => {
        if (!corporateEmail) {
          alert("Corporate Email ID is missing.");
          return false;
        }
        if (
          !formData.permanent_address &&
          !formData.present_address &&
          !formData.present_city &&
          !formData.country
        ) {
          alert("Please fill at least one address field.");
          return false;
        }

        setLoading(true);
        try {
          const accessToken = JSON.parse(localStorage.getItem("emsUser"))?.user?.stsTokenManager?.accessToken;
          const bodyData = {
            corporate_email_id: corporateEmail,
            permanent_address: formData.permanent_address,
            present_address: formData.present_address,
            present_city: formData.present_city,
            country: formData.country,
          };

          const response = await fetch(
            `${process.env.REACT_APP_BACKEND_URL_HRM}/add-address-details`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`,
              },
              body: JSON.stringify(bodyData),
            }
          );

          const data = await response.json();
          if (response.ok) {
            setSnackbarMessage("Address added successfully.");
            setSnackbarSeverity("success");
            setOpenSnackbar(true);
            return true;
          } else {
            setSnackbarMessage(
              data.error || "Error occurred while saving address."
            );
            setSnackbarSeverity("error");
            setOpenSnackbar(true);
            return false;
          }
        } catch (error) {
          setSnackbarMessage("An error occurred while adding address.");
          setSnackbarSeverity("error");
          setOpenSnackbar(true);
          return false;
        } finally {
          setLoading(false);
        }
      };

      const handleUpdate = async () => {
        if (!addressExists) {
          setSnackbarMessage(
            "Cannot update. No address exists for this employee!"
          );
          setSnackbarSeverity("error");
          setOpenSnackbar(true);
          return false;
        }
        
        setLoading(true);
        try {
          const updateData = {
            Permanent_Address: formData.permanent_address,
            Present_Address: formData.present_address,
            Present_City: formData.present_city,
            Country: formData.country,
          };

          const accessToken = JSON.parse(localStorage.getItem("emsUser"))?.user
            ?.stsTokenManager?.accessToken;

          const response = await fetch(
            `${process.env.REACT_APP_BACKEND_URL_HRM}/update-address-details/${employeeId}`,
            {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`,
              },
              body: JSON.stringify(updateData),
            }
          );
            const data = await response.json();
            if (response.ok) {
              if (data.updated === false || data.message === 'No changes detected.') {
                return { success: true, message: "No changes detected." };
              } else {
                setSnackbarMessage("Address updated successfully.");
                setSnackbarSeverity("success");
                setOpenSnackbar(true);
                return { success: true, message: "Address updated." };
              }
            } else {
              setSnackbarMessage(data.error || "Failed to update address.");
              setSnackbarSeverity("error");
              setOpenSnackbar(true);
              return { success: false, message: data.error || "Failed to update address." };
            }
        } catch (error) {
          setSnackbarMessage("An error occurred while updating address.");
          setSnackbarSeverity("error");
          setOpenSnackbar(true);
          return false;
        } finally {
          setLoading(false);
        }
      };

      const validateAddress = () => {

        if (
          !formData.permanent_address &&
          !formData.present_address &&
          !formData.present_city &&
          !formData.country
        ) {
          setSnackbarMessage("Please fill at least one address field.");
          setSnackbarSeverity("error");
          setOpenSnackbar(true);
          return false;
        }

        // Add more field-specific validations if needed

        return true;
      };

    useImperativeHandle(ref, () => ({
      validate: validateAddress,
      save: async (corporateEmail) => {
        return await handleSave(corporateEmail);
      },
      update: async () => {
        const result = await handleUpdate();
        return result; 
        
      }
    }))

    const inputFields = [
      { label: "Permanent Address", name: "permanent_address" },
      { label: "Present Address", name: "present_address" },
      { label: "Present City", name: "present_city" },
      { label: "Country", name: "country" },
    ];

   const customInputSx = {
      borderRadius: "8px",
      backgroundColor: "transparent",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#aaa"
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#aaa !important"
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#aaa !important"
      }
    };

    const customLabelSx = {
      fontSize: "18px",
      fontWeight: "bold",
      color: colors.grey[100],
      "&.Mui-focused": {
        color: colors.grey[100]
      },
      "&.MuiInputLabel-shrink": {
        color: colors.grey[100]
      }
    };

    return (
      <Container sx={{ mt: 4, maxWidth: 800 }}>
        <Typography
          variant="h5"
          align="center"
          sx={{ fontWeight: "bold", color: theme.palette.text.primary, mb: 3 }}
        >
          {employeeId ? "Edit Employee Address" : "Add Employee Address"}
        </Typography>

        <form>
          {inputFields.map(({ label, name }) => (
            <TextField
              key={name}
              label={label}
              name={name}
              value={formData[name] || ""}
              onChange={handleChange}
              fullWidth
              margin="normal"
              required={false}
              InputLabelProps={{
                shrink: true,
                sx: customLabelSx,
              }}
              InputProps={{
                sx: {
                  ...customInputSx,
                  minHeight: "56px",
                  fontSize: "1rem",
                },
              }}
              sx={{
                width: "100%",
                '& .MuiOutlinedInput-root': {
                  borderRadius: "8px",
                  minHeight: "56px",
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: "#aaa",
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: "#aaa !important",
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: "#aaa !important",
                },
                '& .MuiInputBase-input': {
                  padding: "12.5px 14px",
                  fontSize: "1rem",
                  color: theme.palette.text.primary,
                },
              }}
            />
          ))}
        </form>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={3000}
          onClose={() => setOpenSnackbar(false)}
        >
          <Alert
            onClose={() => setOpenSnackbar(false)}
            severity={snackbarSeverity}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Container>
    );
  }
);

export default AppAddressDetails;
